import React from 'react';

// components
import { cn } from '@/utils/cn';
import Icon from '../Icon';
import Text from '../Text';

// utils

function MegaDeal({
  className = '',
  title = 'Mega Deal!',
  gradientColorStart = '#E94D31',
  gradientColorEnd = '#39AA70',
}) {
  return (
    <div
      className={cn(
        'w-max flex items-center gap-[2px] lg:gap-[3px] rounded-tl-8 rounded-br-8 py-2 lg:py-6 pl-4 lg:pl-8 pr-8 lg:pr-12',
        className,
      )}
      style={{
        background: `linear-gradient(to right, ${gradientColorStart}, ${gradientColorEnd})`,
      }}
    >
      <div className="size-[12px] lg:size-[20px]">
        <Icon
          type="mega-deal-star"
          color="#fff"
          className="size-[12px] lg:size-[20px]"
        />
      </div>
      <Text
        type="paragraph"
        className="!text-12 lg:!text-14 text-white !font-encode-sans font-semibold lg:font-bold leading-16 lg:leading-20 tracking-[0.24px] lg:tracking-[0.28px]"
      >
        {title}
      </Text>
    </div>
  );
}

export default MegaDeal;
